import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Capture from "./Pages/PhotoBooth/Capture";
// import Gallery from "./Pages/PhotoBooth/Gallery/gallery";
import "./Assets/css/bootstrap.min.css";
import "./Assets/css/animation.css";
import "./Assets/css/reset.css";
import "./Assets/css/style.css";
import "./Assets/css/form.css";
import "./Assets/css/effectanimation.css";
import "./Assets/css/responsive.css";
import "./Assets/css/custom.css";
import NotFound from "./Pages/404";
// import Login from "./Pages/Login";
import { ErrorContext, UserContext } from "./context";
import List from "./Pages/List";
import SelectBG from "./Pages/PhotoBooth/SelectBG";

export default function App() {
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) setTimeout(() => setError(null), 3000);
  }, [error]); // eslint-disable-line

  return (
    <BrowserRouter basename="/digitalphotobooth/multi-bg">
      <UserContext.Provider value={{ userId, setUserId }}>
        <ErrorContext.Provider value={{ error, setError }}>
          <Routes>
            <Route path="capture/:id" element={<Capture />} />
            <Route path="/" element={<SelectBG />} />

            {/* <Route
              path="/capture"
              element={userId ? <Capture /> : <Navigate to="/" />}
            /> */}

            <Route path="/admin/list" element={<List />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorContext.Provider>
      </UserContext.Provider>
    </BrowserRouter>
  );
}
